import React, { useState } from "react";
import "./Modal.css";
import API_URL from "./config";
import { useAuth } from "../App";

function Modal({ closeModal, onLoginSuccess }) {
  const [isRegister, setIsRegister] = useState(false);
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [registerData, setRegisterData] = useState({ username: "", email: "", password: "", confirmPassword: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    isRegister
      ? setRegisterData((prev) => ({ ...prev, [name]: value }))
      : setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);
  
    try {
      if (isRegister) {
        if (registerData.password !== registerData.confirmPassword) {
          setErrorMessage("Пароли не совпадают");
          setIsLoading(false);
          return;
        }
  
        const response = await fetch(`${API_URL}/auth/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            email: registerData.email,
            password: registerData.password,
            is_active: true,
            is_superuser: false,
            is_verified: false,
            login: registerData.username,
            role_id: 1,
          }), 
        });
  
        if (response.status === 201) {
          alert("Регистрация успешна! Теперь войдите в аккаунт.");
          setIsRegister(false);
          setIsLoading(false);
          return;
        }
  
        const errorData = await response.json();
        throw new Error(errorData.detail || "Ошибка регистрации");
      }
  
      // Авторизация
      const response = await fetch(`${API_URL}/auth/jwt/login`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        credentials: "include",
        body: new URLSearchParams({
          username: loginData.email,
          password: loginData.password,
        }),
      });
  
      if (!response.ok) {
        throw new Error("Неверный email или пароль");
      }
      
      // Проверяем Content-Type ответа
      const contentType = response.headers.get("Content-Type");
      
      // Если сервер вернул JSON, пробуем его получить
      if (contentType && contentType.includes("application/json")) {
        try {
          const data = await response.json();
          if (data && data.access_token) {
            // Используем функцию login из контекста авторизации
            await login(data.access_token);
            if (onLoginSuccess) {
              onLoginSuccess();
            }
            closeModal();
            return;
          }
        } catch (error) {
          console.error("Ошибка при парсинге JSON:", error);
        }
      }
      
      // Если токен пришел в заголовке Authorization
      const authHeader = response.headers.get('Authorization');
      if (authHeader && authHeader.startsWith('Bearer ')) {
        const token = authHeader.substring(7);
        // Используем функцию login из контекста авторизации
        await login(token);
        if (onLoginSuccess) {
          onLoginSuccess();
        }
        closeModal();
        return;
      }
      
      // Если сервер вернул статус 204 (No Content) или другой успешный статус
      if (response.status >= 200 && response.status < 300) {
        try {
          // Пробуем получить информацию о пользователе
          const meResponse = await fetch(`${API_URL}/current`, {
            method: "GET",
            credentials: "include",
          });
            
          if (meResponse.ok) {
            try {
              const userData = await meResponse.json();
              // Используем функцию login из контекста авторизации
              await login(userData.id || "authenticated");
              if (onLoginSuccess) {
                onLoginSuccess();
              }
              closeModal();
              return;
            } catch {
              const token = "authenticated_" + new Date().getTime();
              await login(token);
              if (onLoginSuccess) {
                onLoginSuccess();
              }
              closeModal();
              return;
            }
          }
        } catch (meError) {
          console.error("Ошибка при получении данных пользователя:", meError);
        }
        
        const token = "authenticated_" + new Date().getTime();
        await login(token);
        if (onLoginSuccess) {
          onLoginSuccess();
        }
        closeModal();
        return;
      }
      
      throw new Error("Сервер не вернул токен авторизации или произошла ошибка");
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{isRegister ? "Регистрация" : "Вход"}</h2>

        {errorMessage && <p className="login-error-message">{errorMessage}</p>}

        <form onSubmit={handleSubmit}>
          {isRegister ? (
            <>
              <label>Логин</label>
              <input
                type="text"
                name="username"
                placeholder="Введите логин"
                required
                value={registerData.username}
                onChange={handleChange}
              />

              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder="Введите email"
                required
                value={registerData.email}
                onChange={handleChange}
              />

              <label>Пароль</label>
              <input
                type="password"
                name="password"
                placeholder="Введите пароль"
                required
                value={registerData.password}
                onChange={handleChange}
              />

              <label>Подтвердите пароль</label>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Повторите пароль"
                required
                value={registerData.confirmPassword}
                onChange={handleChange}
              />
            </>
          ) : (
            <>
              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder="Введите email"
                required
                value={loginData.email}
                onChange={handleChange}
              />

              <label>Пароль</label>
              <input
                type="password"
                name="password"
                placeholder="Введите пароль"
                required
                value={loginData.password}
                onChange={handleChange}
              />
            </>
          )}

          <div className="modal-buttons">
            <button type="submit" className="submit-btn" disabled={isLoading}>
              {isLoading ? "Подождите..." : isRegister ? "Зарегистрироваться" : "Войти"}
            </button>
            <button type="button" className="switch-btn" onClick={() => setIsRegister(!isRegister)} disabled={isLoading}>
              {isRegister ? "Уже есть аккаунт?" : "Создать аккаунт"}
            </button>
          </div>
        </form>

        <button className="close-modal-btn" onClick={closeModal}>
          &times;
        </button>
      </div>
    </div>
  );
}

export default Modal;
